'use strict';

angular.module('clientDashboardApp').factory('invoiceService', function ($http) {

  return {
    get: (authenticationKey, subscriptionId, invoiceId) => {
      return $http
        .get('/billingAccounts/' + authenticationKey + '/subscription/' + subscriptionId + '/invoice/' + invoiceId)
        .then(data => data.data)
    },

    list: (authenticationKey, subscriptionId) => $http.get('/billingAccounts/' + authenticationKey + '/subscription/' + subscriptionId + '/invoices')
      .then(data => data.data),
  }
});
